var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.44,
    height: 25,
    viewBox: "0 0 24.44 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "books",
    transform: "translate(-5.522 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(5.522 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M29.949,23.02h0L23.861.3a.406.406,0,0,0-.5-.287L17.88,1.483a.4.4,0,0,0-.192.127V.739a.406.406,0,0,0-.406-.406H5.928a.406.406,0,0,0-.406.406V24.26a.406.406,0,0,0,.406.406H17.282a.406.406,0,0,0,.406-.406V2.332L23.681,24.7a.406.406,0,0,0,.392.3.42.42,0,0,0,.1-.014l5.484-1.47A.406.406,0,0,0,29.949,23.02ZM11.2,23.855H6.333V1.145H11.2Zm5.677,0H12.01V1.145h4.866Zm7.482.243L18.482,2.161,23.182.9,29.06,22.838Z",
    transform: "translate(-5.522 0)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(7.144 2.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M40.361,54.589H37.928a.406.406,0,1,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-37.522 -54.589)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(7.144 4.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M40.361,86.589H37.928a.406.406,0,0,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-37.522 -86.589)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(12.822 2.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M152.361,54.589h-2.433a.406.406,0,0,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-149.522 -54.589)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(12.822 4.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M152.361,86.589h-2.433a.406.406,0,0,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-149.522 -86.589)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(19.771 2.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M289.772,54.9a.406.406,0,0,0-.489-.3l-.021.006-2.352.629a.406.406,0,1,0,.206.784h0l2.353-.63A.406.406,0,0,0,289.772,54.9Z",
    transform: "translate(-286.608 -54.591)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(20.194 4.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M298.111,85.855a.406.406,0,0,0-.5-.287h0l-2.35.63a.406.406,0,1,0,.206.784h0l2.352-.63A.406.406,0,0,0,298.111,85.855Z",
    transform: "translate(-294.96 -85.554)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(24.183 19.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M376.791,379.5a.406.406,0,0,0-.494-.286l-2.352.63a.406.406,0,0,0,.105.8h0a.411.411,0,0,0,.105-.014l2.35-.63A.406.406,0,0,0,376.791,379.5Z",
    transform: "translate(-373.644 -379.205)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(24.606 20.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M385.136,410.416a.406.406,0,0,0-.494-.286l-2.353.63a.406.406,0,0,0,.105.8.392.392,0,0,0,.105-.014l2.352-.629A.406.406,0,0,0,385.136,410.416Z",
    transform: "translate(-381.988 -410.117)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(12.822 19.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M152.361,390.589h-2.433a.406.406,0,0,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-149.522 -390.589)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(12.822 21.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M152.361,422.589h-2.433a.406.406,0,0,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-149.522 -422.589)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(7.144 19.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M40.361,390.589H37.928a.406.406,0,0,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-37.522 -390.589)",
    fill: "#003358"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(7.144 21.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M40.361,422.589H37.928a.406.406,0,0,0,0,.811h2.433a.406.406,0,1,0,0-.811Z",
    transform: "translate(-37.522 -422.589)",
    fill: "#003358"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLibrary);
export default __webpack_public_path__ + "static/media/icon_library.2b22847e03f0d591c59cadb5578703ab.svg";
export { ForwardRef as ReactComponent };